import React, { useEffect } from "react";
import Layout from "../../../layout";
import BackButton from "../../../components/BackButton";
import "./onboarding.css";

const Onboarding = () => {
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const id = hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    }
  }, []);

  return (
    <Layout>
      <BackButton />
      <div>
        <h1 className="ml-2">Welcome to WorkBrook!</h1>
        <p className="ml-2">
          Please find below a quick overview of the main features available on
          the platform:{" "}
        </p>

        <div id="getting-started" className="mt-2 pl-2">
          <div className="mt-2">
            <h2 className="ml-2 onboarding-header-text">
              Getting Started on Workbrook
            </h2>
            <p className="ml-2">
              Welcome to Workbrook! This guide will walk you through the steps
              to set up your account, verify your details, and start exploring
              the platform.
            </p>
          </div>
          <h2 className="ml-2 onboarding-subheader-text">
            Step 1: Access Workbrook
          </h2>
          <p className="ml-2">
            Download the Workbrook mobile app from the Play Store/App Store, or
            visit the web portal at web.workbrook.com.
          </p>
          <h2 className="ml-2 onboarding-subheader-text">Step 2: Sign Up</h2>
          <p className="ml-2">
            Create an account using your email address and a secure password.
            Ensure you use a valid email you can access.
          </p>
          <h2 className="ml-2 onboarding-subheader-text">
            Step 3: Verify Your Account
          </h2>
          <p className="ml-2">
            Check your email for an activation code and enter it in the app/web
            portal.
          </p>
          <h2 className="ml-2 onboarding-subheader-text">
            Step 4: Complete Your Profile
          </h2>
          <p className="ml-2">
            Fill in your personal details, job title, skills, education, and
            work experience. A complete profile increases your chances of
            success on Workbrook. Verify your phone number as well to secure
            your account.
          </p>
          <h2 className="ml-2 onboarding-subheader-text">
            Step 5: Explore Your Dashboard
          </h2>
          <p className="ml-2">
            Once setup is complete, navigate to your dashboard to explore job
            opportunities (for job seekers) or start posting jobs (for
            employers).
          </p>
          <p className="ml-2">Tips for Success:</p>
          <ol className="ml-5">
            <li>
              Keep your profile 100% complete.Use accurate keywords when filling
              in skills and job postings.
            </li>
            <li>
              Use accurate keywords when filling in skills and job postings.
            </li>
            <li>Verify your phone number and email to build credibility.</li>
            <li>Update your CV and experience regularly.</li>
          </ol>
        </div>

        <div id="job-seekers" className="mt-2 pl-2">
          <div className="mt-2">
            <h2 className="ml-2 onboarding-header-text">Job Seekers Guide</h2>
            <p className="ml-2">
              Workbrook makes it easy for you to find and apply for jobs.
            </p>
          </div>
          <h2 className="ml-2 onboarding-subheader-text">
            Step 1: Upload Your CV
          </h2>
          <p className="ml-2">Upload your latest CV to your profile.</p>
          <h2 className="ml-2 onboarding-subheader-text">
            Step 2: Browse and Search for Jobs
          </h2>
          <p className="ml-2">
            Use the job search filters to find roles that fit your skills and
            location.
          </p>
          <h2 className="ml-2 onboarding-subheader-text">
            Step 3: Apply for Jobs
          </h2>
          <p className="ml-2">
            Click Apply on any job posting, attach your CV (if required), and
            submit.
          </p>
          <h2 id="insights" className="ml-2 onboarding-subheader-text">
            Step 4:Track Application Status
          </h2>
          <p className="ml-2">
            From your Insights, monitor the status of your applications
            (applied, under review, hired, or rejected).
          </p>
        </div>

        <div id="employers" className="mt-2 pl-2">
          <div className="mt-2">
            <h2 className="ml-2 onboarding-header-text">
              Employers / Recruiters Guide
            </h2>
            <p className="ml-2">
              Workbrook helps employers post jobs and find qualified candidates
              quickly.
            </p>
          </div>
          <h2 className="ml-2 onboarding-subheader-text">
            Step 1: Request to post a Job
          </h2>
          <p className="ml-2">
            Click Post Job, fill in job details, requirements, and deadlines.
          </p>
          <h2 className="ml-2 onboarding-subheader-text">
            Step 2: Manage Applicants
          </h2>
          <p className="ml-2">
            Review applicants’ CVs, shortlist, and contact candidates directly
            through the platform.
          </p>
          <h2 className="ml-2 onboarding-subheader-text">
            Step 3: Track Job Posting Performance
          </h2>
          <p className="ml-2">
            Check how many people viewed, applied, or were shortlisted.
          </p>
        </div>

        <div id="referring" className="mt-2 pl-2">
          <div className="mt-2">
            <h2 className="ml-2 onboarding-header-text">
              Referring Candidates on Workbrook
            </h2>
            <p className="ml-2">
              Workbrook also allows you to earn rewards by referring others to
              jobs.
            </p>
          </div>
          <h2 className="ml-2 onboarding-subheader-text">
            Step 1: Open a Job Posting
          </h2>
          <p className="ml-2">
            When you view a tier 2 or 3 job, you will see three options:Like,
            Apply and Refer.
          </p>
          <h2 className="ml-2 onboarding-subheader-text">
            Step 2: Select “Refer”
          </h2>
          <p className="ml-2">
            Click Refer if you know someone who would be a strong candidate for
            the role.
          </p>
          <h2 className="ml-2 onboarding-subheader-text">
            Step 3: Share the Job
          </h2>
          <p className="ml-2">Copy or Share the referral link provided.</p>
          <h2 className="ml-2 onboarding-subheader-text">
            Step 4: Track Progress
          </h2>
          <p className="ml-2">
            From your dashboard, monitor the status of your referrals (applied,
            interview, hired, or rejected).
          </p>
          <h2 className="ml-2 onboarding-subheader-text">
            Step 5: Earn Rewards
          </h2>
          <p className="ml-2">
            If your referral is successfully hired, you earn a small
            commission/percentage as a reward.
          </p>
        </div>

        <div id="wallet" className="mt-2 pl-2">
          <div className="mt-2">
            <h2 className="ml-2 onboarding-header-text">Wallet & Payments</h2>
            <p className="ml-2">
              The Workbrook wallet allows you to receive rewards, manage your
              funds, and withdraw securely. All referral bonuses and eligible
              earnings flow into your wallet automatically.
            </p>
          </div>
          <h2 className="ml-2 onboarding-subheader-text">
            Step 1: Access Your Wallet
          </h2>
          <p className="ml-2">From your dashboard, navigate to Wallet.</p>
          <h2 className="ml-2 onboarding-subheader-text">
            Step 2: Understand Your Balances
          </h2>
          <ol className="ml-5">
            <li>
              Book Balance: Funds that are pending (e.g., referral reward
              awaiting hire confirmation).
            </li>
            <li>
              Available Balance: Funds that are cleared and can be withdrawn or
              used.
            </li>
          </ol>
          <h2 className="ml-2 onboarding-subheader-text">
            Step 3: Add Funds via JaraPay
          </h2>
          <p className="ml-2">
            Click on JaraPay, Enter an amount and description
          </p>
          <p className="ml-2">Download Jarapay app or Scan code to pay</p>
          <h2 className="ml-2 onboarding-subheader-text">
            Step 4: Withdraw Your Funds
          </h2>
          <p className="ml-2">
            Click Withdraw, add your account details and confirm the request.
          </p>
          <h2 className="ml-2 onboarding-subheader-text">
            Step 5: Track Transactions
          </h2>
          <p className="ml-2">
            Check your wallet history to view all credits (earnings, rewards)
            and debits (withdrawals).
          </p>
        </div>
        <h1 className="ml-2">Conclusion</h1>
        <p className="ml-2">
          Workbrook is designed to make job applications, hiring, and referrals
          seamless. Whether you’re a job seeker, an employer, or a referrer,
          completing your profile and actively engaging with the platform
          ensures you get the most value.
        </p>
      </div>
    </Layout>
  );
};

export default Onboarding;
